import { Grid, CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { Notification } from '@components';
import { orderStore } from '@store/orders';
import { Show, createMemo } from 'solid-js';

import { CreateEditVendorForm } from './CreateNewVendorOnLoad';

type VendorWithManagementProps = {
  index: number;
};
export const VendorWithManagement = (props: VendorWithManagementProps) => {
  const vendorXrefError = createMemo(() => {
    const errorKey = `vendors[${props.index}].vendorContractXref`;
    return orderStore.orderFormError?.[errorKey]?.[0];
  });

  return (
    <CollapsibleCard
      startTitle="Vendor Details"
      loading={orderStore.loading}
      class="mb-2"
    >
      <Show when={vendorXrefError()}>
        <Notification type="error" text={vendorXrefError()} sxProps="mb-3!" />
      </Show>
      <Notification
        type={'info'}
        text="To search for an existing vendor, enter at least one of the following: Name, Address, or Services Type(s)."
      />
      <Grid size={12} container spacing={4} mt={4}>
        <CreateEditVendorForm index={props.index} />
      </Grid>
    </CollapsibleCard>
  );
};
